import { render, staticRenderFns } from "./Confirm-investment.vue?vue&type=template&id=35989e21&scoped=true"
import script from "./Confirm-investment.vue?vue&type=script&lang=js"
export * from "./Confirm-investment.vue?vue&type=script&lang=js"
import style0 from "./Confirm-investment.vue?vue&type=style&index=0&id=35989e21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35989e21",
  null
  
)

export default component.exports